
// Handle the start of a column drag event
export const handleDragStart = (index, dragColumnIndex) => {

    // Store the index of the column being dragged in a ref
    dragColumnIndex.current = index;

};



// Handle the drop event when a column is dragged and dropped to a new position
export const handleDrop = (dropIndex, dragColumnIndex, columns, setColumns) => {

    // Get the index of the column that was dragged
    const dragIndex = dragColumnIndex.current;

    // If no drag index or dropping in the same place, exit early
    if (dragIndex === null || dragIndex === dropIndex) return;

    // Create a shallow copy of the columns array
    const newCols = [...columns];

    // Remove the dragged column from its original position
    const [removed] = newCols.splice(dragIndex, 1);

    // Insert the dragged column at the new drop position
    newCols.splice(dropIndex, 0, removed);

    // Separate fixed columns (not draggable) from the reorderable ones
    const fixed = newCols.filter(col => col.draggable === false);
    const reorderable = newCols.filter(col => col.draggable !== false);

    // Re-apply the column order: fixed columns first, then reordered columns
    setColumns([...fixed, ...reorderable]);

    // Reset the dragColumnIndex reference
    dragColumnIndex.current = null;
};



// Toggle the expanded/collapsed state for a table row
export const toggleRowExpansion = (id, setExpandedRows) => {

    // Update the expanded rows state
    setExpandedRows((prev) =>

        // If the row is already expanded, remove it; otherwise, add it
        prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]

    );

};



// Toggle the selection state for a single table row
export const toggleRowSelection = (id, setSelectedRows) => {

    // Update the selected rows state
    setSelectedRows(prev =>

        // If already selected, remove it; otherwise, add it
        prev.includes(id) ? prev.filter(index => index !== id) : [...prev, id]

    );

};



// Toggle the selection state for all rows in the current page
export const toggleSelectAllRows = (paginated, selectedRows, setSelectedRows) => {

    // Check if all rows are already selected
    const allSelected = paginated.every(row => selectedRows.includes(row.id));

    // If all are selected, clear selection; otherwise, select all
    setSelectedRows(allSelected ? [] : paginated.map(row => row.id));

};



// Handle the start of a column resize event
export const handleResize = (e, key, columnWidths, columns, setColumnWidths) => {

    // Prevent default behavior while resizing
    e.preventDefault();

    // Capture the initial mouse X position
    const startX = e.clientX;

    // Find the column definition for the key being resized
    const col = columns.find(c => c.key === key);

    // Get the starting width of the column
    const startWidth = columnWidths[key] || col?.minWidth || 150;

    // Handler for mouse move during resize
    const onMouseMove = (e) => {

        // Calculate the new width based on cursor movement
        let newWidth = startWidth + (e.clientX - startX);

        // Apply min width constraint if defined
        if (col.minWidth) newWidth = Math.max(newWidth, col.minWidth);

        // Apply max width constraint if defined
        if (col.maxWidth) newWidth = Math.min(newWidth, col.maxWidth);

        // Update the width in state
        setColumnWidths(prev => ({ ...prev, [key]: newWidth }));

    };

    // Handler for mouse release - ends the resize operation
    const onMouseUp = () => {

        // Remove event listeners once the resize is complete
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);

    };

    // Attach listeners for mouse movement and release
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

};

